// src/modules/chat.js
//
// Chat module manifest.
// Controls: SiteChat panel (Walkie, Team, Customer Chats).

export default {
  id: 'chat',
  label: 'Chat',

  stores: {
    userChatStore: {
      import: () => import('@/stores/userChatStore'),
      storeId: 'userChatStore',
      init: () => {
        /* lazy — SiteChat handles subscription */
      },
      cleanup: store => {
        store.cleanup?.()
      },
    },
    groupChatStore: {
      import: () => import('@/stores/groupChatStore'),
      storeId: 'groupChatStore',
      init: () => {
        /* lazy — SiteChat handles subscription */
      },
      cleanup: store => {
        store.cleanup?.()
      },
    },
    walkieStore: {
      import: () => import('@/stores/walkieStore'),
      storeId: 'walkieStore',
      init: () => {
        /* lazy */
      },
      cleanup: store => {
        store.cleanup?.()
      },
    },
    customerChatStore: {
      import: () => import('@/stores/customerChatStore'),
      storeId: 'customerChat',
      init: () => {
        /* lazy — CustomerChatTab handles initialization */
      },
      cleanup: store => {
        store.cleanup?.()
      },
    },
  },

  globalComponents: {
    SiteChat: () => import('@/components/Communications/SiteChat.vue'),
  },

  routes: [], // Chat has no dedicated route (embedded in SiteChat panel)

  nav: [], // No nav item (SiteChat is always-visible when enabled)
}
